"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/useThrottle.ts
var useThrottle_exports = {};
__export(useThrottle_exports, {
  useThrottle: () => useThrottle
});
module.exports = __toCommonJS(useThrottle_exports);
var import_react = require("react");
var useThrottle = ({
  callback,
  delay,
  skipLeading
}) => {
  const timerData = (0, import_react.useRef)({ lastExec: 0, firstCall: 0 });
  const throttled = (0, import_react.useCallback)(
    (...args) => {
      if (!delay) {
        if (timerData.current.plannedCallback) {
          cancelAnimationFrame(timerData.current.plannedCallback);
          timerData.current.plannedCallback = null;
        }
        timerData.current.plannedCallback = requestAnimationFrame(() => {
          timerData.current.plannedCallback = null;
          callback?.(...args);
        });
        return;
      }
      const now = Date.now();
      const execDiff = timerData.current.lastExec + delay - now;
      const createTimeout = (ms) => {
        clearTimeout(timerData.current.timeout ?? void 0);
        timerData.current.timeout = setTimeout(() => {
          timerData.current.lastExec = Date.now();
          callback?.(...args);
        }, ms);
      };
      if (execDiff < 0) {
        if (skipLeading) {
          let callAfter = timerData.current.firstCall + delay - now;
          if (callAfter < 0) {
            timerData.current.firstCall = now;
            callAfter = delay;
          }
          createTimeout(callAfter);
          return;
        }
        callback?.(...args);
        timerData.current.lastExec = now;
      } else {
        createTimeout(execDiff);
      }
    },
    [callback, delay, skipLeading]
  );
  return throttled;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useThrottle
});
